import moment from 'moment';

// C05 (QA do deploy, 28/09): o componente Data devolve dd/mm/aaaa e a tela mandava isso cru para
// a API, que comparava com a data do evento — o filtro não funcionava. Aqui o período vira
// aaaa-mm-dd e é validado (espelho de PainelFinanceiroPeriodo na API).
// Leitura ESTRITA para o campo (prop `parse` do Data): data inexistente fica inválida e o campo
// mostra o texto digitado, em vez do moment tolerante virar 31/02/2026 em 20/02/2031.
export function momentPainel(valor) {
    if (valor === null || valor === undefined || String(valor).trim() === '') return null;
    return moment(String(valor).trim(), ['DD/MM/YYYY', 'YYYY-MM-DD'], true);
}

export function dataPainelIso(valor) {
    const m = momentPainel(valor);
    if (m === null) return null;
    return m.isValid() ? m.format('YYYY-MM-DD') : false;
}

export function periodoPainel(filtro) {
    const f = filtro || {};
    const inicio = dataPainelIso(f.dataInicio);
    const fim = dataPainelIso(f.dataFim);
    if (inicio === false) return { params: {}, erro: 'Data início inválida. Use dd/mm/aaaa.' };
    if (fim === false) return { params: {}, erro: 'Data fim inválida. Use dd/mm/aaaa.' };
    if (inicio && fim && inicio > fim) return { params: {}, erro: 'A data início não pode ser maior que a data fim.' };
    const params = {};
    if (inicio) params.dataInicio = inicio;
    if (fim) params.dataFim = fim;
    return { params, erro: null };
}
